import { transformOnlyDefinedValues, useGetSimpleApiDataWithTransformer } from '@cp-shared-19/frontend-integration';
import { fetchContracts } from './ContractsSlice';
import { ContractsDataSelector } from './ContractsDataSelector';
import { enrichContracts } from 'cpes-common';

/**
 * Fetches all the contracts
 */
export function useContracts() {
    return useGetSimpleApiDataWithTransformer(
        fetchContracts,
        ContractsDataSelector,
        transformOnlyDefinedValues(enrichContracts),
    );
}
